/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class CollaborativeEditApi {
  async JoinCollaboration(key : string) : Promise<any> {
    return await componentApi.call('st', 'st-collaborative-edit', 'CollaborativeEditApi', 'JoinCollaboration', {
      key,
    });
  }
  async LeaveCollaboration(key : string) : Promise<any> {
    return await componentApi.call('st', 'st-collaborative-edit', 'CollaborativeEditApi', 'LeaveCollaboration', {
      key,
    });
  }
  async SaveValue(srcName : string, identity : string, value : string) : Promise<any> {
    return await componentApi.call('st', 'st-collaborative-edit', 'CollaborativeEditApi', 'SaveValue', {
      srcName,
      identity,
      value,
    });
  }
  async Broadcast(key : string, messageBase64 : string, sourceClientId : string) : Promise<any> {
    return await componentApi.call('st', 'st-collaborative-edit', 'CollaborativeEditApi', 'Broadcast', {
      key,
      messageBase64,
      sourceClientId,
    });
  }
  async GetCursorInfo() : Promise<st.CursorInfo> {
    return await componentApi.call('st', 'st-collaborative-edit', 'CollaborativeEditApi', 'GetCursorInfo', {
    });
  }
}
export default new CollaborativeEditApi()
